import { useTranslation } from "react-i18next";

import type { AutomationSortValue } from "../types";

type SortByOptions = {
  value: AutomationSortValue;
  label: string;
};

export const useSortByOptions = (): SortByOptions[] => {
  const { t } = useTranslation("product", {
    keyPrefix: "automation.listPage.filters.sortByOptions"
  });

  return [
    {
      value: "newest",
      label: t("newest")
    },
    {
      value: "oldest",
      label: t("oldest")
    },
    {
      value: "a-z",
      label: "A-Z"
    },
    {
      value: "z-a",
      label: "Z-A"
    }
  ];
};
